import { render, staticRenderFns } from "./EditFeatures.vue?vue&type=template&id=f36c6728&"
import script from "./EditFeatures.vue?vue&type=script&lang=js&"
export * from "./EditFeatures.vue?vue&type=script&lang=js&"
import style0 from "./EditFeatures.vue?vue&type=style&index=0&id=f36c6728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports